module.exports = __webpack_public_path__ + "img/022.bafdf96b.png";